<template>
  <div id="search-wrap" class="search-wrap column" style="right: 432px; padding-right: 14px;" v-if="showLeagueTeam"  :class="{ 'mini': miniNormal==1,'normal':miniNormal!=1 }">
    <div class="wrap-input">
      <div class="search-icon-container">
        <i aria-hidden="true" role="presentation" class="search-icon q-icon icon-search c-icon set-color" style="color: rgb(171, 186, 200); font-size: 14px;"></i>
      </div>
      <div class="input-wrap col">
        <input type="search" id="searchField" :placeholder="langList.home['HOME.ENTER_LEAGUE_TEAM']" class="search-input col key-is-empty"  @keyup="instantSearch($event)" @click="instantSearch($event)">
        <span class="clear_input">
          <i data-v-082e727f="" aria-hidden="true" role="presentation" class="cursor-pointer clear_input_btn q-icon icon-failure c-icon" style="font-size: 12px;"  @click="clear($event,'')"  v-if="searchVal!=null"> </i>
        </span>
      </div>
      <div class="close-wrap" @click="closeLeagueTeam()">{{  langList.sportTableLang['SPORT_TABLE.LBL_CLOSE'] }}</div>
    </div>
    <div class="bottom-wrap col search-result relative-position" v-show="showLeagueSearch" >
      <div class="sports-tab">
        <div class="tab-wrap fit relative-position">
          <div class="item-wrap relative-position" style="left: 0px;">
            <template v-for="sport in sportList">
              <div class="tab-item yb-flex-center" 
                  v-html="sport.sprtLang" 
                  :class="{ 'active': selectedSportSearch==sport.sprtId }" 
                  @mouseover="hoverSport = sport.sprtId" @mouseleave="hoverSport = selectedSportSearch"
                  :id="'tab-'+sport.sprtId"
                  @click="changeSport($event,sport.sprtId)"> 
              </div>
            </template>
            <div class="line-wrap">
              <div class="line" style="transform: translateX(10px); width: 44px;"></div>
            </div>
          </div>
          <div class="left-btn btn" style="display: none;">
            <div class="yb-icon-arrow"></div>
          </div>
          <div class="right-btn btn" style="display: none;">
            <div class="yb-icon-arrow"></div>
          </div>
        </div>
      </div>
      <div class="wrap-init search-background" style="" >
        <div style="height: 50px;"></div>
        <div class="init-wrap"  v-if="historyList && historyList.length>0 && (searchVal==null||searchVal=='')" >
          <div class="init-row">
            <div class="line"></div>
            <div class="row-title col">{{ langList.statementLang['STATEMENT.LBL_HISTORY'] }}</div>
            <div class="clear-history"  @click="clearSearchHistory">{{ langList.home['HOME.CLEAR_SEARCH_HISTORY'] }}</div>
          </div>
          <template v-for="(history, hIdx) in historyList">
            <div class="histroy-item">
              <div class="ellipsis" @click="pickHistory($event, history)">{{ history }}</div>
              <div data-v-624a6792="">
                <i data-v-082e727f="" aria-hidden="true" role="presentation" class="search_deleteIcon q-icon icon-del c-icon" style="font-size: 8px;"  @click="removeFromHistory(history, hIdx)"></i>
              </div>
            </div>
          </template>
        </div>

        <div class="init-wrap"  v-if="(searchVal==null||searchVal=='')">
          <div class="init-row">
            <div class="line"></div>
            <div class="row-title col">{{ langList.home['HOME.SEARCH_HOT'] }}</div>
            <div class="clear-history" @click="changeSearche()"> {{ langList.home['HOME.CHANGE'] }} </div>
          </div>
          <template v-if="templateSearch">
            <div class="hot histroy-item" @click="clear($event,langList.home['HOME.SEARCH_LEAGUE4'])"> 1&ensp;&ensp;{{ langList.home['HOME.SEARCH_LEAGUE4'] }}  </div>
            <div class="hot histroy-item" @click="clear($event,langList.home['HOME.SEARCH_LEAGUE5'])"> 2&ensp;&ensp;{{ langList.home['HOME.SEARCH_LEAGUE5'] }}  </div>
            <div class="hot histroy-item" @click="clear($event,langList.home['HOME.SEARCH_LEAGUE6'])"> 3&ensp;&ensp;{{ langList.home['HOME.SEARCH_LEAGUE6'] }}  </div>
          </template>
          <template v-else>
            <div class="hot histroy-item" @click="clear($event,langList.home['HOME.SEARCH_LEAGUE1'])"> 1&ensp;&ensp;{{ langList.home['HOME.SEARCH_LEAGUE1'] }} </div>
            <div class="hot histroy-item" @click="clear($event,langList.home['HOME.SEARCH_LEAGUE2'])"> 2&ensp;&ensp;{{ langList.home['HOME.SEARCH_LEAGUE2'] }} </div>
            <div class="hot histroy-item" @click="clear($event,langList.home['HOME.SEARCH_LEAGUE3'])"> 3&ensp;&ensp;{{ langList.home['HOME.SEARCH_LEAGUE3'] }}  </div>
          </template>
        </div>

        <div data-v-26cf9bde="" data-v-43f1557a="" class="result-wrap" v-if="searchVal!=null && searchVal!=''" style="overflow: auto;" :style="'max-height:'+LeftMenu_heightPX+'px !important'" >
          <template v-if="Object.keys(searchedList).length>0 || Object.keys(searchedListRB).length>0 ">
            <template v-if="Object.keys(searchedListRB).length>0">
              <div data-v-26cf9bde="" class="type-item active inplay">
                <div data-v-26cf9bde="" class="type-wrap">
                  <div data-v-26cf9bde="" class="line"></div>
                  <div data-v-26cf9bde="" class="type-name">{{ langList.home['HOME.INPLAY'] }}</div>
                </div>
                <template v-for="(list, lkey) in searchedListRB">
                  <div data-v-26cf9bde="" class="league-item active">
                    <div data-v-26cf9bde="" class="league-wrap">
                      <div data-v-26cf9bde="" class="name-wrap">
                        <div data-v-26cf9bde="" class="league-name"></div>
                        <div data-v-26cf9bde="" class="league-total">0</div>
                      </div>
                    </div>
                    <div data-v-26cf9bde=""  v-for="(eventlist, ekey) in list"  class="match-item">
                      <div data-v-26cf9bde="" class="text-wrap">
                        <template v-if="eventlist['eve'+langid+'cap'] || eventlist['eve1cap']">
                          <template v-if="eventlist['eve'+langid+'cap']">
                              <div  data-v-26cf9bde="" class="team" v-html="highlightText(eventlist['eve'+langid+'cap'], searchVal)"></div>
                          </template>
                          <template v-else>
                              <div data-v-26cf9bde="" class="team" v-html="highlightText(eventlist['eve1cap'], searchVal)"></div>
                          </template>
                        </template>
                        <template v-else>
                          <div data-v-26cf9bde="" class="team" @click="enterAllBet(eventlist);">
                            <template v-if="eventlist['ta'+langid+'cap']">
                                <span data-v-3c47a8b4=""v-html="highlightText(eventlist['ta'+langid+'cap'], searchVal)"></span>
                            </template>
                            <template v-else>
                                <span data-v-3c47a8b4=""  v-html="highlightText(eventlist['ta1cap'], searchVal)"></span>
                            </template>
                            &ensp;v&ensp;
                            <template v-if="eventlist['tb'+langid+'cap']">
                                <span data-v-3c47a8b4="" v-html="highlightText(eventlist['tb'+langid+'cap'], searchVal)"></span>
                            </template>
                            <template v-else>
                                <span data-v-3c47a8b4="" v-html="highlightText(eventlist['tb1cap'], searchVal)"></span>
                            </template>
                          </div>
                        </template>
                      </div>
                      <div data-v-26cf9bde="" class="text-wrap">
                        <div data-v-ab1566a6="" data-v-26cf9bde="" class="c-match-process text-center vrow a-row">
                          <div data-v-ab1566a6="" class="jingcai" style="display: none;"></div>
                          <div data-v-ab1566a6="" class="process-name">
                            <template v-if="eventlist.rbinfo" > <!---->
                              <template v-if="eventlist.sportid==1">
                                <template v-if="eventlist.rbinfo.htst == '0'">
                                  <span class="timeInfo">{{ langList.sportTableLang['SPORT_TABLE.LBL_HT'] }}</span>
                                </template>
                                <template v-else-if="validateRBTimer(eventlist) == '1'">
                                  <span class="timeInfo">{{ langList.sportTableLang['SPORT_TABLE.LBL_1HT'] }}</span>
                                </template>
                                <template v-else-if="validateRBTimer(eventlist) == '2'">
                                  <span class="timeInfo">{{ langList.sportTableLang['SPORT_TABLE.LBL_2HT'] }}</span>
                                </template>
                                <template v-else> - </template>
                              </template>
                              <template v-else-if="eventlist.sportid==2"> 
                                <template v-if="eventlist.rbinfo.htst == '1'"><span class="timeInfo">{{ langList.sportTableLang['SPORT_TABLE.LBL_Q1'] }}</span></template>
                                <template v-else-if="eventlist.rbinfo.htst == '2'"><span class="timeInfo">{{ langList.sportTableLang['SPORT_TABLE.LBL_Q2'] }}</span></template>
                                <template v-else-if="eventlist.rbinfo.htst == '3'"><span class="timeInfo">{{ langList.sportTableLang['SPORT_TABLE.LBL_Q3'] }}</span></template>
                                <template v-else-if="eventlist.rbinfo.htst == '4'"><span class="timeInfo">{{ langList.sportTableLang['SPORT_TABLE.LBL_Q4'] }}</span></template>
                                <template v-else-if="eventlist.rbinfo.htst == '5'"><span class="timeInfo">{{ langList.sportTableLang['SPORT_TABLE.LBL_1HT'] }}</span></template>
                                <template v-else-if="eventlist.rbinfo.htst == '6'"><span class="rb_timeHT">{{ langList.sportTableLang['SPORT_TABLE.LBL_HT'] }}</span></template>
                                <template v-else-if="eventlist.rbinfo.htst == '7'"><span class="timeInfo">{{ langList.sportTableLang['SPORT_TABLE.LBL_2HT'] }}</span></template>
                                <template v-else-if="eventlist.rbinfo.htst == '8'"><span class="timeInfo">{{ langList.sportTableLang['SPORT_TABLE.LBL_OT'] }}</span></template>
                                <template v-else> - </template>
                              </template>
                            </template>
                          </div>
                          <div data-v-ab1566a6="" class="c-match-date text-center date-wrap">
                            <template v-if="eventlist.rbinfo">
                              <template v-if="eventlist.sportid==1"> 
                                <template v-if="eventlist.rbinfo.htst == '0'">
                                </template>
                                <template v-else-if="validateRBTimer(eventlist) == '1'">
                                  <template v-if="eventlist.rbinfo.tlsec">
                                    {{ eventlist | rb-timer('mm:ss') }}
                                  </template>
                                  <template v-else>0</template>
                                </template>
                                <template v-else-if="validateRBTimer(eventlist) == '2'">
                                    {{ eventlist | rb-timer('mm:ss') }}
                                </template>
                              </template>
                              <template v-else-if="eventlist.sportid==2">
                                <template v-if="eventlist.rbinfo.htst == '0'"></template>
                                <template v-else>
                                    <template v-if="selectedLang==2 || selectedLang==3"><br></template>
                                    <template v-if="eventlist.rbinfo.evetm">{{ eventlist | rb-timer }}</template>
                                </template>
                              </template>
                            </template>
                            <template v-else>
                              <span style="min-width: 60px;">
                                <template v-if="selectedLang == 2 || selectedLang == 3">
                                    {{ moment(matchDateCheck(eventlist.evedt)).locale('cn').format("MMM Do") }}
                                </template>
                                <template v-else>
                                  {{ matchDateCheck(eventlist.evedt) | date('DD/MM') }}
                                </template>
                                <br></span>
                              <span>{{ matchDateCheck(eventlist.evedt) | date('HH:mm') }}</span>
                            </template>
                            
                             
                            <!--div data-v-17aa71f1="" class="timer-layout relative-position">
                              <span data-v-17aa71f1="" class="timer-layout0">
                                <template v-if="eventlist.rbinfo" >
                                  
                                </template>
                                <template v-else>
                                   <span style="min-width: 60px;">
                                    <template v-if="selectedLang == 2 || selectedLang == 3">
                                      {{ moment(eventlist.evedt).locale('cn').format("MMM Do") }}
                                    </template>
                                    <template v-else>
                                      {{ eventlist.evedt | date('DD/MM') }}
                                    </template>
                                    <br></span>
                                  <span>{{ eventlist.evedt | date('HH:mm') }}</span>
                              </span>
                            </div-->
                            <span style="display: none;"></span> 
                          </div>
                        </div>
                        <div data-v-26cf9bde="" class="score">
                          <template v-if="eventlist.rbinfo">
                              <template v-if="eventlist.sportid==1 || eventlist.sportid==2"> 
                                {{ eventlist.rbinfo.scoa }}-{{ eventlist.rbinfo.scob }}
                              </template>
                            </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </template>
            <template v-if="Object.keys(searchedList).length>0">
              <div data-v-26cf9bde="" class="type-item active">
                <div data-v-26cf9bde="" class="type-wrap">
                  <div data-v-26cf9bde="" class="line"></div>
                  <div data-v-26cf9bde="" class="type-name">{{ langList.home['HOME.TEAM'] }}</div>
                </div>
                <template v-for="(list, lkey) in searchedList">
                  <div data-v-26cf9bde="" class="league-item active">
                    <div data-v-26cf9bde="" class="league-wrap">
                      <div data-v-26cf9bde="" class="name-wrap" @click="searchLeagueList(list[0])">
                        <template v-if="list[0]['lge'+langid+'cap']">
                          <div data-v-26cf9bde="" class="league-name" v-html="highlightText(list[0]['lge'+langid+'cap'], searchVal)"></div>
                        </template>
                        <template v-else>
                          <div data-v-26cf9bde="" class="league-name" v-html="highlightText(list[0]['lge1cap'], searchVal)"></div>
                        </template>
                        <div data-v-26cf9bde="" class="league-total">{{ list.length }}</div>
                      </div>
                    </div>
                    <div data-v-26cf9bde=""  v-for="(eventlist, ekey) in list"  class="match-item">
                      <div data-v-26cf9bde="" class="text-wrap">
                        <template v-if="eventlist['eve'+langid+'cap'] || eventlist['eve1cap']">
                          <template v-if="eventlist['eve'+langid+'cap']">
                              <div  data-v-26cf9bde="" class="team" v-html="highlightText(eventlist['eve'+langid+'cap'], searchVal)"></div>
                          </template>
                          <template v-else>
                              <div data-v-26cf9bde="" class="team" v-html="highlightText(eventlist['eve1cap'], searchVal)"></div>
                          </template>
                        </template>
                        <template v-else>
                          <div data-v-26cf9bde="" class="team"  @click="enterAllBet(eventlist);">
                            <template v-if="eventlist['ta'+langid+'cap']">
                                <span data-v-3c47a8b4=""v-html="highlightText(eventlist['ta'+langid+'cap'], searchVal)"></span>
                            </template>
                            <template v-else>
                                <span data-v-3c47a8b4=""  v-html="highlightText(eventlist['ta1cap'], searchVal)"></span>
                            </template>
                            &ensp;v&ensp;
                            <template v-if="eventlist['tb'+langid+'cap']">
                                <span data-v-3c47a8b4="" v-html="highlightText(eventlist['tb'+langid+'cap'], searchVal)"></span>
                            </template>
                            <template v-else>
                                <span data-v-3c47a8b4="" v-html="highlightText(eventlist['tb1cap'], searchVal)"></span>
                            </template>
                          </div>
                        </template>
                      </div>
                      <div data-v-26cf9bde="" class="text-wrap">
                        <div data-v-ab1566a6="" data-v-26cf9bde="" class="c-match-process text-center vrow a-row">
                          <div data-v-ab1566a6="" class="jingcai" style="display: none;"></div>
                          <div data-v-ab1566a6="" class="process-name"></div>
                          <div data-v-ab1566a6="" class="c-match-date text-center date-wrap">
                            <span style="min-width: 60px;">
                              <template v-if="selectedLang == 2 || selectedLang == 3">
                                {{ moment(matchDateCheck(eventlist.evedt)).locale('cn').format("MMM Do") }}
                              </template>
                              <template v-else>
                                {{ matchDateCheck(eventlist.evedt) | date('DD/MM') }}
                              </template>
                               <br></span>
                            <span>{{ matchDateCheck(eventlist.evedt) | date('HH:mm') }}</span>
                          </div>
                        </div>
                        <div data-v-26cf9bde="" class="score"></div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </template>
          </template>
          <template v-else>
            <div data-v-21f17103="" data-v-26cf9bde="" class="load-data-wrap col fit not-list">
              <div data-v-21f17103="" class="column yb-flex-center empty fit">
                <div data-v-3fbff0d7="" data-v-21f17103="" class="wrap empty-wrap" style="margin-bottom: 0px;">
                  <div data-v-31145778="" class="img dark" style="width: 180px; height: 180px;"></div>
                  <div data-v-31145778="" class="text-center">{{ langList.home['HOME.SEARCH_EMPTY'] }}</div>
                  <div data-v-31145778="" class="nodata-text2">{{ langList.home['HOME.SEARCH_TRY_OTHER'] }}</div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      
      <div class="play-wrap search-background" style="display: none;"></div>
    </div>
  </div>
</template>

<script>
import EventBus from '../../../events/event-bus'
import moment from 'moment'
import 'moment/locale/zh-cn'
import DateFilter from '@/vue/filters/date'
import allBetMixin from '@/vue/mixins/allBet'

import {
  mapGetters
} from 'vuex'


export default {
  mixins: [allBetMixin],
  components: {
    // contentsRight,
    // contentHeader,
    // sportTable,
    // soccerAllCommon,
    
  },
  data() {
    return {
      templateSearch:false,
      searchedList: null,
      searchedListRB: null,
      cookies_lang: window._cookie,
      langid: '',
      searchVal: null,
      searchSelected: false,
      inputText: '',
      selectedSportSearch: 'N1',
      hoverSport: 'N1',
      selectedSportId: '1',
      selectedLang: window._langid,
      moment: moment,
      sportBettypeList: window.sportBettypeList,
    }
  },
  computed: {
    ...mapGetters([
      'langList',
   //   'sportTableLang',
     // 'sportResultsLang',
      'showLeagueTeam',
      'sportList',
      'selectedSport',
      'bettypeList',
      'historyList',
      'searchLoading',
      'cookieHistory',
      'filterEventArr',
      'miniNormal',
      'frameWidthHeight',
      'showLeagueSearch',
      'searchLeague'
    ]),
    LeftMenu_heightPX: function () {
        return this.$store.getters.frameWidthHeight.height.currentHeight-160
    },
  },
  watch: {
    bool_leagueToggle(){
      //toggle open league box
      if(this.$store.getters.bool_leagueToggle){
        var ht = window.innerHeight - 100
        this.heightPX = ht + 'px'
      }
    },
    hoverSport:function(val){

      var position = $("#tab-"+val).first().position();
      var center =  position.left + $("#tab-"+val).width()/2.3;
      $('.sports-tab .line').css('transform','translateX('+ center +'px)')
      
    }
  },
  methods: {
    clear(e,text){
      $('#searchField').val(text)
      this.instantSearch(e)
    },
    matchDateCheck(date){
      return moment.utc(date).utcOffset(this.$store.getters.timeZone.list[this.$store.getters.timeZone.default][1]).format("YYYY-MM-DD HH:mm:ss")
    },
    instantSearch(e) {
      this.$store.commit('SHOW_LEAGUESEARCH',true);
      this.$store.commit('SEARCH_LOADING',true)
      let vue = this
      let data = ''
      let dataRB = ''
      let typing = ''
      vue.searchVal = $('#searchField').val()
      clearTimeout(typing)
      typing = setTimeout(() => {
        if(vue.inputText != vue.searchVal){
          vue.inputText = vue.searchVal
          if(vue.searchVal!=''){
            this.$store.commit('COOKIE_HISTORY', {
              searchVal : vue.searchVal,
              remove : false,
              removeSelected : false,
            })
            vue.$store.commit('HIST_LIST', vue.$store.getters.cookieHistory)
          }
          vue.$store.commit('SEARCH_LOADING',false)
        }
      }, 2000);
      if(e.code == 'Backspace' || vue.searchVal == ''){
          vue.searchedList = null
          vue.searchedListRB = null
          vue.$store.commit('SEARCH_LOADING',false)
      }
      if(vue.searchVal!=null && vue.searchVal != ''){
          var filEventArr = vue.filterEventArr
          if(filEventArr[0]=="NOEVENT"){
            filEventArr=[];
          }
          dataRB = _.filter(filEventArr, function(o,u) {
            if(o['sportid']){
              o['sptid']=o['sportid']
              if(o['rbstatus']==1  && vue.selectedSportSearch.replace("N", "")==o['sportid']){
                if(o['lge'+vue.langid+'cap'] && o['lge'+vue.langid+'cap'].toLowerCase().indexOf(vue.searchVal.toLowerCase()) > -1){
                  return true
                }else if(o['lge1cap'] && o['lge1cap'].toLowerCase().indexOf(vue.searchVal.toLowerCase()) > -1){
                    return true
                }
                if(o['ta'+vue.langid+'cap'] && o['ta'+vue.langid+'cap'].toLowerCase().indexOf(vue.searchVal.toLowerCase()) > -1){
                    return true
                }else if(o['ta1cap'] && o['ta1cap'].toLowerCase().indexOf(vue.searchVal.toLowerCase()) > -1){
                    return true
                }
                if(o['tb'+vue.langid+'cap'] && o['tb'+vue.langid+'cap'].toLowerCase().indexOf(vue.searchVal.toLowerCase()) > -1){
                    return true
                }else if(o['tb1cap'] && o['tb1cap'].toLowerCase().indexOf(vue.searchVal.toLowerCase()) > -1){
                    return true
                }
              }
            }
          })
          data = _.filter(filEventArr, function(o,u) {
            if(o['sportid']){
              o['sptid']=o['sportid']
              if(o['rbstatus']==0  && vue.selectedSportSearch.replace("N", "")==o['sportid']){
                if(o['lge'+vue.langid+'cap'] && o['lge'+vue.langid+'cap'].toLowerCase().indexOf(vue.searchVal.toLowerCase()) > -1){
                  return true
                }else if(o['lge1cap'] && o['lge1cap'].toLowerCase().indexOf(vue.searchVal.toLowerCase()) > -1){
                    return true
                }
                if(o['ta'+vue.langid+'cap'] && o['ta'+vue.langid+'cap'].toLowerCase().indexOf(vue.searchVal.toLowerCase()) > -1){
                    return true
                }else if(o['ta1cap'] && o['ta1cap'].toLowerCase().indexOf(vue.searchVal.toLowerCase()) > -1){
                    return true
                }
                if(o['tb'+vue.langid+'cap'] && o['tb'+vue.langid+'cap'].toLowerCase().indexOf(vue.searchVal.toLowerCase()) > -1){
                    return true
                }else if(o['tb1cap'] && o['tb1cap'].toLowerCase().indexOf(vue.searchVal.toLowerCase()) > -1){
                    return true
                }
              }
            }
          })
      }
      //store search data to array
      this.searchedList = _(data)
                          .groupBy(o => o.lgeid)
                          .value();
      this.searchedListRB = _(dataRB)
                          .groupBy(o => o.lgeid)
                          .value();
    },
    changeSearche(){
      this.templateSearch=!this.templateSearch
    },
    closeLeagueTeam(){
      this.searchVal = ''
      this.$store.commit('SHOW_LEAGUETEAM', false);
      if(this.searchLeague.lid>0){
        let lgeList={};
        lgeList.lid=0;
        lgeList.lname='';
        this.$store.commit('SEARCH_LEAGUE', lgeList);
        EventBus.$emit('refreshOdd', true);
      }
    },
    getLangid() {
        let vue = this

        if(vue.cookies_lang == 'zh_TW'){
            vue.langid = 3
        }else if(vue.cookies_lang == 'zh_CN'){
            vue.langid = 2
        }else if(vue.cookies_lang == 'th_TH'){
            vue.langid = 5
        }else if(vue.cookies_lang == 'vn_VN'){
            vue.langid = 6
        }else{
            vue.langid = 1
        }
    },
    highlightText(words, searchText) {
      /*
        function pregQuote (str) {
            return (str.trim() + '').replace(/([\\\.\+\*\?\[\^\]\$\(\)\{\}\=\!\<\>\/\:])/g, "\\$1")
        }
        if(this.searchText!=""){
            var iQuery = new RegExp(pregQuote(searchText), 'ig')
            return words.toString().replace(iQuery, function(matchedTxt,a,b){
                return ('<span style="color:#FFB001">' + matchedTxt + '</span>');
            })
        }*/
        return words
    },
    hidePopUp(){
      this.$store.commit('SHOW_FILTER')
    },
    clearSearchHistory(){
      let vue = this
      this.$store.commit('COOKIE_HISTORY', {
        searchVal : vue.searchVal,
        remove : true,
        removeSelected : false,
      })
      this.$store.commit('HIST_LIST', [])
    },
    changeSport(e, sptid){
      this.selectedSportSearch = sptid 
      this.selectedSportId = sptid.replace("N", ""); 
      this.$store.dispatch('getFilterEventList',{
        'sportid': this.selectedSportId
      })
      if(this.searchVal!=''){
        this.instantSearch(e)
      }
    },
    modifyDate(date){
      let nDateTime = date.split(' ')

      let nDate = nDateTime[0]

      let nDt = nDate.split('/')

      return nDt[1] + '/' + nDt[2] + ' ' + nDateTime[1]
    },
    pickHistory(e, history){
      this.searchVal = history
      $('#searchField').val(history)
      this.instantSearch(e)
    },
    removeFromHistory(history, hIdx){
      let cookies = this.$store.getters.historyList
      let data = _.filter(cookies, function(o,key){
        return key != hIdx
      })
      this.$store.commit('HIST_LIST', data)

      this.$store.commit('COOKIE_HISTORY', {
        searchVal : history,
        remove : false,
        removeSelected : true,
      })
    },
    modifyEventId(eveid){
      return (eveid - 1000) * 2
    },
    selectSearchBox(){
      $('#searchField').focus()
      this.searchSelected = true
    },
    enterAllBet(eve) {
        this.$store.commit('FIRSTEVENT',[])
        this.$store.commit('SORTEDMATCHEVENTLIST', [])
        this.$store.commit('SELECTED_MATCHALLBET', false)
        
        let market = 1
        if(eve.evetype == 0){
            market = 1
        }else if(eve.evetype == 1){
            market = 2
        }else if(eve.evetype == 2){
            market = 3
        }
        this.$store.commit('SELECTED_MARKET', market)
        EventBus.$emit('refreshOdd', true);
        eve.eveid = this.modifyEventId(eve.eveid)
        eve.sptid= eve.sportid
        eve.dt= eve.evedt
        eve.filtersptid= eve.sportid
        this.searchVal =null;
        $('#searchField').val('')
        this.closeLeagueTeam();
        this.$store.dispatch('getMatchAllBet', {
          event: eve,
          isRB: (eve.rbstatus==1) ? true : false,
          token: token.arr_8,
          loadTemplate: 3  // 1 open right score board only, 2 open live tv, 3 open right score board + all bet, 0 all bet only
        })
        this.$store.commit('SHOW_LEAGUETEAM', false);
        this.$store.commit('SHOW_LEAGUESEARCH', false);
    },
    searchLeagueList(lge) {
      let lgeList={};
      lgeList.lid=lge['lgeid'];
      lgeList.lname=lge['lge1cap'];
      if(lge['lge'+this.langid+'cap']){
        lgeList.lname=lge['lge'+this.langid+'cap'];
      }
      $('#searchField').val(lgeList.lname)
      this.$store.commit('SEARCH_LEAGUE', lgeList);
      
      let market = 1
      if(lge.evetype == 0){
          market = 1
      }else if(lge.evetype == 1){
          market = 2
      }
      this.$store.commit('SELECTED_MARKET', market)
      EventBus.$emit('refreshOdd', true);
      this.$store.commit("GAMEBANNER_SELECTED", false);
      this.$store.commit('STATEMENT_SHOW_STATEMENT', false)
      this.$store.commit('SELECTED_ALLBET', false)
      this.$store.commit('SELECTED_MATCHALLBET', false)
      this.$store.commit('SPORT_SHOW_FAV_EVENTS', false)
      this.$store.commit('OPEN_RBMARKET', false)
      this.$store.commit('SHOW_LEAGUESEARCH',false);
      EventBus.$emit('viewAccountSetting', false)
      let sportList={}
      sportList.sprtId = this.selectedSportSearch
      this.$store.commit('SELECTED_SPORT', sportList);
      this.commitBettypeList()
      this.$store.commit('SELECTED_BETTYPE',  _.cloneDeep(this.$store.getters.bettypeList[0]))
      EventBus.$emit('sportChange', this.$store.getters.selectedBettype );
      this.$store.commit('SHOW_LEAGUETEAM', false);
      this.$store.commit('SHOW_LEAGUESEARCH', false);
    },
    checkTimer(event) {
        return this.$options.filters.checkTimer(event)
    },
    commitBettypeList() {
        this.$store.commit('BETTYPELIST',
            _.filter(
                this.sportBettypeList,
                {
                    'sprtId' : this.selectedSportSearch
                }
            )
        )
    },
    getFilterEventList(){
      this.$store.dispatch('getFilterEventList',{
        'sportid': this.selectedSportId
      })
    }
  },
  
  mounted () {
    let Vue=this
    this.getLangid()
    $(document).mouseup(function(e) {
      var container = $("#search-wrap");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        Vue.searchVal =null;
        $('#searchField').val('')
        Vue.closeLeagueTeam();
      }
    });
  },
  beforeMount(){
    this.getFilterEventList()
    EventBus.$on("getLatestFilterEventList", (res) => {
      this.getFilterEventList()
    });
    this.$store.commit('HIST_LIST', this.$store.getters.cookieHistory)
  },
  beforeDestroy() {
      EventBus.$off("getLatestFilterEventList");
  },
}
</script>



// WEBPACK FOOTER //
// resources/wob/vue/apps/home/contentsMain/searchLeagueTeam.vue